import { Provider, useSelector } from "react-redux";

import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import "./custom.scss";
import { store } from "./store";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import Register from "./pages/auth/Register";
import Login from "./pages/auth/Login";
import "./App.css";
import NotFound from "./components/NotFound";
import WebsiteNotFound from "./components/WebsiteNotFound";
import Dashboard from "./pages/dashboard/Dashboard";
import Layout from "./components/Layout";
import PrivateRoute from "./components/PrivateRoute";
import MyDelivery from "./pages/dashboard/Builder/MyDelivery";
import DeliveryRequest from "./pages/dashboard/Builder/DeliveryRequest";
import DeliveryPerson from "./pages/dashboard/Builder/DeliveryPerson";
import DeliverySettings from "./pages/dashboard/Builder/DeliverySettings";

import LandingPage from "./pages/LandingPage/LandingPage";
import EditProfile from "./pages/dashboard/Builder/EditProfile";
import PickUpPage from "./pages/dashboard/Builder/PickUpPage";
import { fetchProtectedData } from "./features/auth/authSlice";
import { getAuthCookie } from "./utils/cookie";
import PrivacyPolicy from "./pages/LandingPage/PrivacyPolicy";
import DeleteAccount from "./pages/dashboard/Builder/DeleteAccount";
import PartnerSupport from "./pages/PartnerSupport";
function App() {
  return (
    <Provider store={store}>
      <AuthCheck />
    </Provider>
  );
}

const AuthCheck = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const token = getAuthCookie();
    if (token) {
      dispatch(fetchProtectedData());
    }
  }, [dispatch]);

  return (
    <Router>
      <Routes>
        <Route
          path="/*"
          element={
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/auth/register" element={<Register />} />
              <Route path="/auth/login" element={<Login />} />
              <Route
                path="/dashboard"
                element={
                  <Layout>
                    <PrivateRoute>
                      <Dashboard />
                    </PrivateRoute>
                  </Layout>
                }
              />
              <Route
                path="/my-deliveries"
                element={
                  <Layout>
                    <PrivateRoute>
                      <MyDelivery />
                    </PrivateRoute>
                  </Layout>
                }
              />
              <Route
                path="/delivery-person"
                element={
                  <Layout>
                    <PrivateRoute>
                      <DeliveryPerson />
                    </PrivateRoute>
                  </Layout>
                }
              />
              <Route
                path="/delivery-request"
                element={
                  <Layout>
                    <PrivateRoute>
                      <DeliveryRequest />
                    </PrivateRoute>
                  </Layout>
                }
              />
              <Route
                path="/profile"
                element={
                  <Layout>
                    <PrivateRoute>
                      <EditProfile />
                    </PrivateRoute>
                  </Layout>
                }
              />

              <Route
                path="/delivery-settings"
                element={
                  <Layout>
                    <PrivateRoute>
                      <DeliverySettings />
                    </PrivateRoute>
                  </Layout>
                }
              />
              <Route path="/partner-support" element={<PartnerSupport />} />
              <Route
                path="/account-deletion"
                element={
                  <PrivateRoute>
                    <DeleteAccount />
                  </PrivateRoute>
                }
              />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/" element={<Navigate to="/auth/login" replace />} />
              <Route path="/not-found" element={<WebsiteNotFound />} />
              <Route path="/*" element={<NotFound />} />
              <Route path="/pickup/:id" element={<PickUpPage />} />
            </Routes>
          }
        />
      </Routes>
    </Router>
  );
};

export default App;
